const AllOvertimes = () => import("./views/AllOvertimes.vue");
export default [
  {
    path: "all",
    component: AllOvertimes,
  },
];
